import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router';

import { buildEmbedHirePortContextValue } from '@/components/route/embedHirePortContext';
import { PageFallback } from '@/components/route/PageFallback';
import { HirePortContextProvider } from '@/hooks/useHirePortContext';
import { getEmbedPackFromPathname } from '@/theme/partnerThemes';

/**
 * Eager embed shell: applies partner theme from the URL before lazy embed
 * chunks suspend, so the first Spin uses pack primary (not Hireport green).
 */
const EmbedThemeLayout = () => {
  const { pathname } = useLocation();
  const pack = getEmbedPackFromPathname(pathname);

  const hirePortContextValue = useMemo(
    () => (pack ? buildEmbedHirePortContextValue(pack) : undefined),
    [pack],
  );

  return (
    <HirePortContextProvider value={hirePortContextValue}>
      <Suspense fallback={<PageFallback />}>
        <Outlet />
      </Suspense>
    </HirePortContextProvider>
  );
};

export default EmbedThemeLayout;
